import { JsonConverter, JsonDiscriminatorProperty, JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapCultureTo } from "../base-types";
import DataType from "../contracts/base/data-type";
import { MemberConditionResourceConverter } from "../converters/member-condition-resource-converter";
import { MemberConditionResource } from "./member-condition-resource";
@JsonObject()
@JsonDiscriminatorProperty("type")
export abstract class MemberDefinitionResource {
    @JsonProperty("type")
    readonly type: DataType;

    @JsonProperty("name")
    name: string;

    @JsonProperty("allow_updates")
    allowUpdates: boolean;

    @JsonProperty("is_system_owned")
    isSystemOwned: boolean;

    @JsonProperty("is_secured")
    isSecured: boolean;

    @JsonProperty("labels")
    labels: MapCultureTo<string> = {};

    @JsonProperty("helptext")
    helpText: MapCultureTo<string> = {};

    @JsonProperty("conditions")
    @JsonElementType(MemberConditionResource)
    @JsonConverter(MemberConditionResourceConverter)
    conditions: Array<MemberConditionResource> = [];

    @JsonProperty("is_conditional")
    isConditional: boolean;

    @JsonProperty("can_trigger_conditional_members")
    canTriggerConditionalMembers: boolean;

    @JsonProperty("can_write")
    canWrite: boolean;

    constructor(type: DataType) {
        this.type = type;
    }
}
